import script from "./ZenteteBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ZenteteBar.vue?vue&type=script&setup=true&lang=js"

import "./ZenteteBar.vue?vue&type=style&index=0&id=033b0d82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-033b0d82"]])

export default __exports__